import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios';
import VueExcelXlsx from "vue-excel-xlsx";

Vue.config.productionTip = false

axios.defaults.baseURL = 'http://api.corporacionideascaribe.com/api/'
//http://localhost/cms-corporation-ideas/public/api/
//http://api.corporacionideascaribe.com/api/
//http://52.0.172.153
//axios.defaults.baseURL = 'http://api.corporacionideascaribe.com/api/'

if(localStorage.getItem('access_token')){
  store.dispatch('getUser');
}

// Init Excel
Vue.use(VueExcelXlsx);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
